export enum DirectionOptions {
  ASC = 'asc',
  DESC = 'desc',
}
